<template>
  <el-dialog
    :visible.sync="visible"
    width="860px"
    custom-class="normal-dialog full-dialog"
    :close-on-click-modal="false"
    :append-to-body="true"
  >
    <div class="dialog-title-content" slot="title">
      <div class="dialog-title-back" v-if="nextStep" @click="nextHandle()">
        <i class="el-icon-arrow-left"></i>
        <span>返回</span>
      </div>
      <course-creater-header-step :active="2" v-else />
    </div>

    <div class="course-creater-pay" v-loading="loading" element-loading-text="创建课题中，请稍候">
      <template v-if="nextStep">
        <course-creater-pay-pane
          v-if="nextStep === 'pay'"
          :productDetail="currentProduct"
          @paySuccess="orderId => confirmHandle(orderId)"
        >
          <div>
            <span>支付成功之后，您的课题可导入案例数上限为 </span>
            <span :style="{ color: '#1991fb' }">{{ actLockTotal.toLocaleString() }}</span>
            <span> 条，且仅限于一次课题内使用。课题创建成功后，将无法变更数据，请考虑清楚后再支付。</span>
          </div>
        </course-creater-pay-pane>
        <course-creater-tip
          v-if="nextStep === 'tip'"
          :lockTotal="productLockTotal"
          :caseTotal="actCaseTotal"
          @back="nextHandle()"
          @confirm="confirmHandle(currentProduct.orderIds[0])"
        />
      </template>
      <template v-else>
        <div class="product-content">
          <div class="form-content">
            <div v-loading="totalLoading">
              <div class="form-item" v-loading="totalLoading">
                <span class="form-item-title">一次课题可导入案例数上限为：</span>
                <template v-if="currentProduct">
                  <div class="product-picker-content">
                    <div class="picker-container" :class="productExpand ? 'is-expand' : ''">
                      <div class="limit-price-content">
                        <div class="limit-content">
                          <span>{{ currentProduct.dataSize.toLocaleString() }} 个</span>
                          <span> / </span>
                          <span class="price" v-if="currentProduct.isFree">免费试用</span>
                          <span class="price" v-else-if="currentProduct.orderIds.length">已支付</span>
                          <span class="price" v-else>￥{{ currentProduct.price }}</span>
                        </div>
                      </div>
                      <div class="expand-content">
                        <i class="iconfont iconshouqi" v-if="productExpand"></i>
                        <i class="iconfont iconzhankai" v-else></i>
                      </div>
                    </div>
                    <div class="product-ul" id="productUl" v-show="productExpand">
                      <div
                        v-for="item in productList"
                        :key="`${item.id}_${item.dataSize || 0}`"
                        class="product-li"
                        :class="isDisabled(item, actCaseTotal || caseTotal) ? 'is-disabled' : ''"
                        @click="checkProductHandle(item)"
                      >
                        <div class="limit-price-content">
                          <div class="limit-content">
                            <span>{{ item.dataSize.toLocaleString() }} 个</span>
                            <span> / </span>
                            <span class="price" v-if="item.isFree">免费试用</span>
                            <span class="price" v-else-if="item.orderIds.length">已支付</span>
                            <span class="price" v-else>￥{{ item.price }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="product-li">
                        <div class="limit-price-content" :style="{ justifyContent: 'center' }">
                          <div class="limit-content">
                            <span>超过5万数据请联系客服</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <span class="filter-total">
                    <span>（已筛选</span>
                    <span>{{ actCaseTotal.toLocaleString() }}</span>
                    <span>个）</span>
                  </span>
                </template>
              </div>
              <div class="form-item" v-if="currentProduct">
                <template v-if="currentProduct.isFree">
                  <span class="pick-product-tip">
                    <span>试用课题的数据量案例数为</span>
                    <span>
                      {{
                        (currentProduct.dataSize >= actCaseTotal
                          ? actCaseTotal
                          : currentProduct.dataSize
                        ).toLocaleString()
                      }}
                    </span>
                    <span>个，请您返回筛选数据重新筛选文书日期。</span>
                  </span>
                </template>
                <template v-else-if="currentProduct.dataSize >= actCaseTotal">
                  <span class="pick-product-tip">案例导入规则：按文书日期由新到旧导入</span>
                </template>
                <template v-else>
                  <span class="pick-product-tip">
                    <span>当前筛选的数据量已超过限制。系统将会按照文书日期最近开始排序推送</span>
                    <span> {{ currentProduct.dataSize.toLocaleString() }} </span>
                    <span>个案例导入课题。</span>
                  </span>
                </template>
              </div>
            </div>
            <div class="bottom-tools" :style="{ marginTop: '40px' }">
              <template v-if="currentProduct">
                <el-button
                  type="primary"
                  :disabled="!actCaseTotal"
                  @click="nextHandle('tip')"
                  v-if="currentProduct.orderIds.length > 0"
                >
                  <span>立即创建课题</span>
                </el-button>
                <el-button type="primary" :disabled="!actCaseTotal" @click="nextHandle('pay')" v-else>
                  <span>支付</span>
                  <span> ￥{{ currentProduct.price.toLocaleString() }} </span>
                  <span>创建课题</span>
                </el-button>
              </template>
              <el-button @click="visible = false">
                <span>返回筛选数据</span>
              </el-button>
            </div>
          </div>
          <div class="product-detail-conetnt">
            <div class="product-detail-header">
              <i class="iconfont iconquanyi icon"></i>
              <span>套餐权益</span>
            </div>
            <div v-show="currentProduct">
              <productTipPane :product="currentProduct" />
            </div>
            <el-button type="text" v-if="currentProduct" :style="{ marginTop: '6px' }" @click="routeToProduct">
              <span>查看产品权益对比</span>
              <i :style="{ marginLeft: '5px' }" class="el-icon-arrow-right"></i>
            </el-button>
          </div>
        </div>
      </template>
    </div>
  </el-dialog>
</template>

<script>
import courseCreaterPayPane from './courseCreaterPayPane';
import courseCreaterTip from './courseCreaterTip';
import productTipPane from './productTipPane';
import courseCreaterHeaderStep from '@/components/courseCreater/courseCreaterHeaderStep';

import { services } from '@/service';
import { mapGetters } from 'vuex';
import { sortBy, minBy, maxBy } from 'lodash';
import { formatProductInfo } from '@/lib/utils';
import { sysCaseWays } from '@/constant';

export default {
  components: { courseCreaterPayPane, courseCreaterTip, productTipPane, courseCreaterHeaderStep },
  data() {
    return {
      nextStep: '',
      actCaseTotal: 0,
      currentProduct: null,
      totalLoading: false,
      productList: [],
      productExpand: false
    };
  },
  inject: ['getQuery'],
  props: {
    show: {
      type: Boolean,
      default: false
    },
    caseTotal: {
      type: Number,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    instrumentType: {
      type: String,
      required: true
    }
  },
  computed: {
    visible: {
      get() {
        return this.show;
      },
      set(val) {
        if (this.loading) {
          return;
        }
        this.$emit('update:show', val);
      }
    },
    ...mapGetters(['orders']),
    productLockTotal() {
      return this.currentProduct ? this.currentProduct.dataSize : 0;
    },
    actLockTotal() {
      if (this.productLockTotal > this.actCaseTotal) {
        return this.actCaseTotal;
      }
      return this.productLockTotal;
    }
  },
  watch: {
    async productExpand(val) {
      if (!val) {
        return;
      }
      await this.$nextTick();
      window.document.getElementById('productUl').scrollTop = 0;
    }
  },
  beforeDestroy() {
    window.removeEventListener('click', this.mouseClickHandle);
  },
  created() {
    window.addEventListener('click', this.mouseClickHandle);
    this.getProductList();
  },
  methods: {
    isDisabled(item, total) {
      if (item.orderIds.length > 0 || !item.minDataSize) {
        return false;
      }
      return item.minDataSize > total;
    },
    routeToProduct() {
      window.open(`${location.origin}${location.pathname}#/product`, '_blank');
    },
    async getTotal() {
      try {
        this.totalLoading = true;
        const caseQuery = this.getQuery();
        if (sysCaseWays.includes(this.instrumentType)) {
          let isProfession = 1;
          if (this.currentProduct && this.currentProduct.isFree) {
            isProfession = 0;
          }
          const res = await services.courseware.getCaseCount({
            size: 0,
            ...caseQuery,
            is_profession: isProfession
          });
          this.actCaseTotal = res.total;
        } else {
          this.actCaseTotal = await services.courseware.fetchAdministrativeCount(caseQuery);
        }
      } catch (err) {
        this.$error(err);
      } finally {
        this.totalLoading = false;
      }
    },
    async getProductList() {
      try {
        this.totalLoading = true;
        let [result] = await Promise.all([services.authriozation.getProductList(), this.$store.dispatch('getOrders')]);
        const productCountByOrder = {};
        this.orders.forEach(orderItem => {
          if (!productCountByOrder[orderItem.product.id]) {
            productCountByOrder[orderItem.product.id] = [];
          }
          productCountByOrder[orderItem.product.id].push({
            orderId: orderItem.id,
            couldUsedCount: orderItem.course_total_num - orderItem.course_used_num,
            productDetail: orderItem.product
          });
        });
        result = result
          .map(productItem => {
            const detail = formatProductInfo(productItem);
            const availableOrders = [...(productCountByOrder[productItem.id] || [])];
            if (availableOrders.length > 0) {
              delete productCountByOrder[productItem.id];
            }
            const orderIds = [];
            let couldUsedCount = 0;
            availableOrders.forEach(orderItem => {
              orderIds.push(orderItem.orderId);
              couldUsedCount += orderItem.couldUsedCount;
            });
            return { ...detail, orderIds, couldUsedCount };
          })
          .filter(productItem => {
            if (productItem.isFree && productItem.orderIds.length === 0) {
              return false;
            }
            return true;
          });
        Object.keys(productCountByOrder).forEach(productId => {
          const details = productCountByOrder[productId].map(o => {
            return {
              orderId: o.orderId,
              couldUsedCount: o.couldUsedCount,
              productInfo: formatProductInfo(o.productDetail)
            };
          });
          const productInfoObj = {};
          details.forEach(o => {
            const idAndSize = `${o.productInfo.id}/${o.productInfo.dataSize}`;
            if (!productInfoObj[idAndSize]) {
              productInfoObj[idAndSize] = [];
            }
            productInfoObj[idAndSize].push(o);
          });
          Object.keys(productInfoObj).forEach(idAndSize => {
            const infoArr = productInfoObj[idAndSize];
            const orderIds = [];
            let couldUsedCount = 0;
            infoArr.forEach(info => {
              orderIds.push(info.orderId);
              couldUsedCount += info.couldUsedCount;
            });
            result.push({ ...infoArr[0].productInfo, orderIds, couldUsedCount });
          });
        });
        const preArr = [];
        const nextArr = [];
        sortBy(result, 'dataSize').forEach(productItem => {
          if (productItem.orderIds.length > 0) {
            preArr.push(productItem);
          } else {
            nextArr.push(productItem);
          }
        });
        this.productList = [...preArr, ...nextArr];
        const pickItem = this.authPickProduct(this.productList);
        this.checkProductHandle(pickItem);
      } catch (err) {
        this.$error(err);
      }
    },
    authPickProduct(productList) {
      const haveOrderProductList = [];
      productList.forEach(productItem => {
        if (productItem.orderIds.length) {
          haveOrderProductList.push(productItem);
        }
      });
      const arr = (haveOrderProductList.length ? haveOrderProductList : productList).map(productItem => {
        const maxDiffNum = productItem.dataSize - this.caseTotal;
        return {
          diffNum: maxDiffNum,
          productItem
        };
      });
      let closeItem = null;
      const arr2 = arr.filter(item => item.diffNum >= 0);
      if (arr2.length > 0) {
        closeItem = minBy(arr2, 'diffNum');
      } else {
        closeItem = maxBy(arr, 'diffNum');
      }
      return closeItem.productItem;
    },
    checkProductHandle(item) {
      if (this.currentProduct === item) {
        this.productExpand = false;
        return;
      }
      const disabled = this.isDisabled(item, this.actCaseTotal || this.caseTotal);
      if (disabled) {
        return;
      }
      this.productExpand = false;
      this.currentProduct = item;
      this.getTotal();
    },
    nextHandle(mode = '') {
      if (this.loading) {
        return;
      }
      if (this.totalLoading) {
        this.$message.warning('课题案例限制获取中，请稍等...');
        return;
      }
      this.nextStep = mode;
    },
    confirmHandle(orderId) {
      this.$emit('confirm', {
        orderId,
        callback: ({ isSuccess, isFail }) => {
          if (isFail) {
            this.nextStep = '';
            this.getProductList();
          }
          if (isSuccess) {
            this.$store.dispatch('getOrders');
          }
        }
      });
    },
    mouseClickHandle(e) {
      let parent = e.target;
      while (parent) {
        if ((parent.className || '').includes('picker-container')) {
          this.productExpand = true;
          return;
        }
        if ((parent.className || '').includes('product-ul')) {
          return;
        }
        parent = parent.parentNode;
      }
      if (this.productExpand) {
        this.productExpand = false;
        return;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.dialog-title-content {
  .dialog-title-back {
    cursor: pointer;
    & > i {
      margin-right: 5px;
    }
  }
}
.course-creater-pay {
  .price {
    color: #f62733;

    .price-num {
      font-weight: 500;
    }
  }

  .product-content {
    display: flex;
    height: 470px;

    .form-content {
      box-sizing: border-box;
      flex: 1;
      width: 0;
      height: 100%;
      overflow-x: hidden;
      overflow-y: auto;
      padding: 40px;

      .form-item {
        display: flex;
        align-items: center;

        .pick-product-tip {
          font-size: 12px;
          line-height: 17px;
          color: #77839e;
          margin-top: 14px;
        }
        .form-item-title {
          font-size: 14px;
          color: #2c3443;
          margin-right: 10px;
        }
        .filter-total {
          font-size: 12px;
          color: #3d465a;
        }
      }

      .import-content {
        .import-count {
          color: #1991fb;
        }

        .import-warning-tip {
          font-size: 12px;
          line-height: 17px;
          color: #f62733;
          margin-bottom: 10px;
        }
      }

      .product-current-tip {
        font-size: 12px;
        line-height: 17px;
        color: #77839e;
        margin-top: 6px;
        margin-bottom: 6px;
      }

      .product-picker-content {
        box-sizing: border-box;
        position: relative;
        cursor: pointer;
        width: 230px;

        .limit-price-content {
          box-sizing: border-box;
          flex: 1;
          width: 0;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 16px;
          color: #2c3443;
          font-size: 14px;

          .limit-content {
            .iconfont {
              color: #1991fb;
              font-size: 14px;
              margin-right: 4px;
            }
          }
          .price-content {
            .gray {
              font-size: 12px;
              color: #77839e;
            }
          }
        }

        .product-ul {
          position: absolute;
          top: 55px;
          left: 0;
          width: 100%;
          max-height: 325px;
          overflow-y: auto;
          background-color: #fff;
          box-shadow: 0px 3px 7px 2px rgba(69, 79, 99, 0.21);
          border-radius: 4px;
          z-index: 10;

          .product-li {
            box-sizing: border-box;
            display: flex;
            height: 46px;
            border-bottom: 1px solid #e8ebef;

            &:hover {
              background-color: #eaf6ff;
            }

            &:last-child {
              border-bottom: 0;
            }

            &.is-disabled {
              cursor: not-allowed;
              background-color: #f8fafd !important;

              .limit-price-content {
                color: #77839e;

                .iconfont {
                  color: #77839e;
                }
              }
              .price {
                color: #77839e;
              }
            }
          }
        }

        .picker-container {
          box-sizing: border-box;
          display: flex;
          height: 46px;
          border: 1px solid #d2d8e3;
          border-radius: 4px;

          .expand-content {
            box-sizing: border-box;
            width: 40px;
            line-height: 44px;
            text-align: center;
            border-left: 1px solid #d2d8e3;
            color: #a0acc0;

            .iconfont {
              font-size: 12px;
            }
          }
          &:hover,
          &.is-expand {
            border-color: #1991fb;

            .expand-content {
              border-color: #1991fb;
              background-color: #1991fb;
              color: #fff;
            }
          }
        }
      }
    }
    .product-detail-conetnt {
      box-sizing: border-box;
      width: 220px;
      height: 100%;
      background-color: #f8fafd;
      padding: 20px 16px;
      overflow: auto;

      .product-detail-header {
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        color: #2c3443;

        .icon {
          color: #ffc400;
          margin-right: 8px;
        }
      }
    }
  }
}
</style>
